import { createFileRoute } from '@tanstack/react-router';
import { GlossaryPage } from '@/features/metric-hub/glossary/GlossaryPage';
import { useTrackSkillOnDwell } from '@/features/metric-hub/onboarding/use-skill-tracker';

function GlossaryRoute() {
  useTrackSkillOnDwell('add_glossary_term');
  return <GlossaryPage />;
}

export const Route = createFileRoute('/_authed/metric-hub/glossary')({
  component: GlossaryRoute,
});
